import { TableColumn } from "./dataInterface";

export const paymentConfirmTableColumn: TableColumn = {
  title: "明細管理",
  detail: true,
  detailTitle: "明細詳細",
  detailColumn: "詳細",
  detailKey: ["id"],
  addTitle: "",
  editAuth: [],
  tableFunction: [],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "payment",
      name: "明細年月",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "payment_year_month",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "payment_state",
      name: "ステータス",
      tableDetailAuth: ["マスターアカウント"],
      table: true,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "status_chip",
      serch: true,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: false,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "payment_company_status",
      name: "入金・出金",
      tableDetailAuth: ["マスターアカウント"],
      table: true,
      tableMinWidth: "140px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: false,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "trading_type",
      name: "取引種類",
      tableDetailAuth: ["マスターアカウント"],
      table: true,
      tableMinWidth: "85px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: false,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "contract_number",
      name: "申込番号",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "high_rank_company_name",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "high_rank_company",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "product_name",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "product",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "service_name",
      name: "サービス名",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "trading_name",
      name: "単価名",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: true,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "pm_payment_method",
      name: "支払方法-上位店明細",
      tableDetailAuth: ["マスターアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "bubun",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "ctt_payment_method",
      name: "支払方法-エントリー",
      tableDetailAuth: ["マスターアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "bubun",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "ctt_payment_method",
      name: "支払方法",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "bubun",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "price_type",
      name: "単価区分",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: false,
      tableMinWidth: "80px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: false,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "customer_list_id",
      name: "顧客-リストID",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: false,
      tableMinWidth: "80px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "kanzen",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "customer_phone_number",
      name: "顧客-電話番号",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "kanzen",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "customer_name",
      name: "顧客-氏名",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "apply_date",
      name: "申込日",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: true,
      tableMinWidth: "80px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "date",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "opening_date",
      name: "開通日",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: true,
      tableMinWidth: "80px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "date",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "cancell_date",
      name: "解約日",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: true,
      tableMinWidth: "80px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "date",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "payment_date",
      name: "上位店入金日",
      tableDetailAuth: ["マスターアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "date",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "high_rank_company_payment_value",
      name: "上位店入金額",
      tableDetailAuth: ["マスターアカウント"],
      table: true,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "bubun",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "high_rank_company_payment_value",
      name: "上位店入金額 (実費)",
      tableDetailAuth: ["マスターアカウント"],
      table: false,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "bubun",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "deposit_value",
      name: "上位店入金単価",
      tableDetailAuth: ["マスターアカウント"],
      table: false,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "bubun",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "entry_sale_company_name",
      name: "エントリーパートナー",
      tableDetailAuth: ["マスターアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "payment_sale_company_name",
      name: "振込先パートナー",
      tableDetailAuth: ["マスターアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_account_name",
      name: "トスアップアカウント",
      tableDetailAuth: ["マスターアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_company_name",
      name: "トスアップパートナー",
      tableDetailAuth: ["マスターアカウント", "パートナー"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sale_account_name",
      name: "営業アカウント",
      tableDetailAuth: ["パートナー"],
      table: true,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "sale_account",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sale_account_name",
      name: "営業アカウント",
      tableDetailAuth: ["マスターアカウント"],
      table: false,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "sale_account",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sale_company_payment_value",
      name: "パートナー支払単価",
      tableDetailAuth: ["マスターアカウント"],
      table: false,
      tableMinWidth: "130px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: false,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "staff_account_name",
      name: "スタッフアカウント",
      tableDetailAuth: ["マスターアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "staff_account",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "operation_value",
      name: "業務管理手数料",
      tableDetailAuth: ["マスターアカウント"],
      table: false,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "office_value",
      name: "事務手数料",
      tableDetailAuth: ["マスターアカウント"],
      table: false,
      tableMinWidth: "80px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "partner_transfer",
      name: "振込金額",
      tableDetailAuth: ["マスターアカウント"],
      table: true,
      tableMinWidth: "60px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "partner_transfer",
      name: "支払金額",
      tableDetailAuth: ["パートナー"],
      table: true,
      tableMinWidth: "60px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sale_amount",
      name: "利益金額",
      tableDetailAuth: ["マスターアカウント"],
      table: true,
      tableMinWidth: "60px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
  ],
  spTier: 'sp_first',
  subTable: [],
};
